import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Hook personalizado para manejar el logout
 * Centraliza la lógica de cierre de sesión y navegación
 */
export function useLogout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return handleLogout;
}




